module.exports = __webpack_public_path__ + "img/u_ava.55a20a10.png";